import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { IAMAccountEntityRaw } from "@youm-front/iam-account/domain";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  IAMAccountCreateRequestDTO,
  IAMAccountCreateResponseDTO,
  IAMAccountCredentialsUpdateRequestDTO,
  IAMAccountCredentialsUpdateResponseDTO,
  IAMAccountDeleteRequestDTO,
  IAMAccountsListResponseDTO,
  IAMAccountUpdateRequestDTO,
  IAMAccountUpdateResponseDTO
} from "../dtos";

@Injectable()
export class IAMAccountsService {
  constructor(private readonly apiService: ApiService) {}

  iamAccountCreate(
    iamAccountCreateRequestDTO: IAMAccountCreateRequestDTO
  ): Observable<IAMAccountCreateResponseDTO> {
    const { identity } = iamAccountCreateRequestDTO.data;

    return this.apiService
      .post<{ account: IAMAccountEntityRaw }>("iam/accounts", { identity })
      .pipe(
        map((_) => new IAMAccountCreateResponseDTO({ account: _.account }))
      );
  }

  iamAccountCredentialsUpdate(
    iamAccountCredentialsUpdateRequestDTO: IAMAccountCredentialsUpdateRequestDTO
  ): Observable<IAMAccountCredentialsUpdateResponseDTO> {
    const { accountId } = iamAccountCredentialsUpdateRequestDTO.data;

    return this.apiService
      .post<{ account: IAMAccountEntityRaw }>(
        `iam/accounts/${accountId}/credentials`,
        {}
      )
      .pipe(
        map(
          (_) =>
            new IAMAccountCredentialsUpdateResponseDTO({ account: _.account })
        )
      );
  }

  iamAccountDelete(
    iamAccountDeleteRequestDTO: IAMAccountDeleteRequestDTO
  ): Observable<void> {
    const { accountId } = iamAccountDeleteRequestDTO.data;

    return this.apiService.delete<void>(`iam/accounts/${accountId}`);
  }

  iamAccountsList(): Observable<IAMAccountsListResponseDTO> {
    return this.apiService
      .get<{ accounts: IAMAccountEntityRaw[] }>("iam/accounts")
      .pipe(
        map(
          (_) =>
            new IAMAccountsListResponseDTO({
              accounts: _.accounts
            })
        )
      );
  }

  iamAccountUpdate(
    iamAccountUpdateRequestDTO: IAMAccountUpdateRequestDTO
  ): Observable<IAMAccountUpdateResponseDTO> {
    const { accountId, identity } = iamAccountUpdateRequestDTO.data;

    return this.apiService
      .put<{ account: IAMAccountEntityRaw }>(`iam/accounts/${accountId}`, {
        identity
      })
      .pipe(
        map(
          (_) =>
            new IAMAccountCreateResponseDTO({
              account: _.account
            })
        )
      );
  }
}
